<template lang="pug">
  button.v-btn(
    :class="classes"
    :disabled="loading || disabled"
    @click="onClick")
    span.v-btn__content
      slot
    .v-btn__loader(v-if="loading")
      v-loader
</template>

<script>
export default {
  name: 'VBtn',

  props: {
    ghost: Boolean,
    icon: Boolean,
    square: Boolean,
    block: Boolean,
    text: Boolean,
    danger: Boolean,
    yellow: Boolean,
    gray: Boolean,
    accent: Boolean,
    loading: Boolean,
    disabled: Boolean,
    medium: Boolean,
    small: Boolean,
    fab: Boolean,
    right: Boolean
  },

  methods: {
    onClick () {
      this.$emit('click')
    }
  },

  computed: {
    classes () {
      return {
        'v-btn--ghost': this.ghost,
        'v-btn--icon': this.icon,
        'v-btn--square': this.square,
        'v-btn--block': this.block,
        'v-btn--text': this.text,
        'v-btn--danger': this.danger,
        'v-btn--yellow': this.yellow,
        'v-btn--gray': this.gray,
        'v-btn--default': !this.danger,
        'v-btn--loading': this.loading,
        'v-btn--disabled': this.disabled,
        'v-btn--accent': this.accent,
        'v-btn--small': this.small,
        'v-btn--medium': this.medium,
        'v-btn--fab': this.fab,
        'v-btn--right': this.right
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/sass/abstracts/_variables.scss';

  .v-btn {
    position: relative;
    cursor: pointer;
    padding: 1rem 1.5rem;
    font-size: 1.7rem;
    font-weight: 300;
    transition: .3s;
    border-radius: .8rem;
    min-width: 10rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    span {
      display: inline-flex;
      align-items: center;
      white-space: nowrap;
    }

    &:focus {
      outline: none;
    }

    &__loader {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &--default {
      color: $color-white;
      background-color: $color-primary;
    }

    &:hover {
      background-color: lighten($color-primary, 3%);
    }

    &:active {
      background-color: darken($color-primary, 1%);
    }

    &--fab {
      position: fixed;
      right: 2rem;
      bottom: 2rem;
      min-width: 5.5rem;
      height: 5.5rem;
      padding: 0;
      border-radius: 50%;
      box-shadow: .2rem .2rem 1rem rgba($color-black, .25);
      background-color: $color-primary;
      z-index: 999;
    }

    &--right {
      right: 10rem;
    }

    &--small {
      font-size: 1.5rem;
    }

    &--medium {
      padding: 1.1rem 2.5rem;
    }

    &--block {
      width: 100%;
    }

    &--icon {
      height: 3.2rem;
      min-width: 3.2rem;
      padding: 0;
      border-radius: 50%;

      &:active {
        background-color: transparent;
      }
    }

    &--square {
      height: 4.1rem;
      min-width: 4.1rem;
      padding: 0;
      border-radius: 1rem;


      &.v-btn--gray {
        color: $color-black;
        background-color: $color-gray-light-2;

        &:hover {
          background-color: darken($color-gray-light-2, 5%);
        }
      }
    }

    &--disabled {
      color: $color-gray!important;
      font-weight: 400;
      cursor: not-allowed;

      &:not(.v-btn--icon) {
        background-color: $color-gray-light-2 !important;
      }

      &.v-btn--icon {
        opacity: .3;
      }
    }

    &--loading {

      &:not(.v-btn--icon) {
        background-color: $color-primary !important;
      }

      &.v-btn--icon {
        .v-loader-button__icon {
          height: 2rem;
          width: 2rem;
          margin: 1.45rem;
          border: .3rem solid $color-primary;
          border-color: $color-primary transparent transparent transparent;
        }
      }

      span {
        visibility: hidden;
      }
    }

    &--danger {
      color: $color-white;
      font-weight: 400;
      background-color: $color-red;

      &:hover {
        background-color: lighten($color-red, 10%);
      }

      &:active {
        background-color: darken($color-red, 5%);
      }
    }

    &--yellow {
      background-color: $color-yellow;

      &:hover {
        background-color: darken($color-yellow, 2%);
      }

      &:active {
        background-color: lighten($color-yellow, 2%);
      }
    }

    &--gray {
      color: $color-gray;
      background-color: transparent;

      &:hover {
        background-color: transparent;
      }
    }

    &--text,
    &--icon {
      color: $color-black;
      font-weight: 400;
      background-color: transparent;

      &:hover {
        background-color: rgba($color-black, 0.07);
      }

      &:active {
        background-color: rgba($color-black, 0.1);
      }

      &.v-btn--danger {
        color: $color-red;
        background-color: rgba($color-red, 0.05);
        &:hover {
          background-color: rgba($color-red, 0.1);
        }

        &:active {
          background-color: rgba($color-red, 0.1);
        }
      }

      &.v-btn--accent {
        color: $color-green;

        &:hover {
          background-color: rgba($color-green-light-2, .2);
        }
      }
    }

    &--ghost {
      padding: 0;
      font-weight: 400;
      color: $color-black;
      justify-content: flex-start;
      background-color: transparent;

      &:hover {
        color: $color-green;
        background-color: transparent!important;
      }

      &:active {
        color: darken($color-green, 5);
        background-color: transparent!important;
      }

      &.v-btn--danger {
        background-color: transparent!important;

        &:hover {
          color: $color-red !important;
          background-color: transparent!important;
        }
      }
    }
  }
</style>
